module.exports = __webpack_public_path__ + "20250721160708/img/empty.96211b4f.png";